/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const manageLoopFieldAssignmentsRequestSchema = z.object({
  fieldIds: z.array(z.int()),
});
